import { CloseOutlined } from "@ant-design/icons";
import { Image as AntImage, Spin } from "antd";
import { useStorageDownloadUrl } from "../lib/useStorageDownloadUrl";

export interface ImageThumbProps {
  path: string;
  onRemove?: () => void;
}

export default function ImageThumb({ path, onRemove }: ImageThumbProps) {
  const { url, failed } = useStorageDownloadUrl(path);

  return (
    <div className="sendin-image-strip">
      {url ? (
        <AntImage src={url} alt="Bilde av innsendingen" preview />
      ) : (
        <div className="sendin-image-strip-placeholder">
          {failed ? "Kunne ikke laste bildet" : <Spin />}
        </div>
      )}
      {onRemove ? (
        <button
          type="button"
          className="sendin-image-strip-remove"
          aria-label="Fjern bilde"
          onClick={onRemove}
        >
          <CloseOutlined />
        </button>
      ) : null}
    </div>
  );
}
